import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
import { useCallback } from "react";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { DestinationWalletSelect } from "../../../../../components/DestinationWalletSelect";
export const SwapDestination = t0 => {
  const $ = _c(20);
  const {
    className
  } = t0;
  const {
    setValue,
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    errors
  } = useFormState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== control) {
    t3 = {
      control,
      name: "recipient",
      defaultValue: t2
    };
    $[3] = control;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const recipient = useWatch(t3);
  let t4;
  if ($[5] !== control) {
    t4 = {
      control,
      name: "toCurrency"
    };
    $[5] = control;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const toCurrency = useWatch(t4);
  let t5;
  if ($[7] !== setValue) {
    t5 = walletDestination => {
      setValue("recipient.identifier", walletDestination.identifier || walletDestination.address);
      setValue("recipient.resolvedAddress", walletDestination.address, {
        shouldValidate: true
      });
    };
    $[7] = setValue;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onWalletSelect = t5;
  let t6;
  if ($[9] !== className) {
    t6 = classNames("p-4", className);
    $[9] = className;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = toCurrency?.chainIdentifier;
  const t8 = recipient.isResolving ? undefined : errors.recipient?.identifier?.message ?? errors.recipient?.resolvedAddress?.message;
  let t9;
  if ($[11] !== recipient.identifier || $[12] !== recipient.resolvedAddress) {
    t9 = recipient.identifier || recipient.resolvedAddress ? {
      address: recipient.resolvedAddress ?? "",
      identifier: recipient.identifier
    } : undefined;
    $[11] = recipient.identifier;
    $[12] = recipient.resolvedAddress;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onWalletSelect || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <DestinationWalletSelect className={t6} destinationChain={t7} error={t8} onWalletSelect={onWalletSelect} walletDestination={t9} />;
    $[14] = onWalletSelect;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};